function goToTop() {
	var button = document.querySelector('[data-gototop]');
	if (!button) {
		button = document.createElement('div');
		button.className = 'GoToTop';
		button.setAttribute('aria-hidden', true);
		button.setAttribute('data-gototop', true);
		button.innerHTML = '<svg alt="" aria-hidden="true" class="Icon Icon--arrowUp"><use xlink:href="#Icon--arrowUp"></use></svg>';
		document.body.appendChild(button);
	}
	var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	var scroll = 0;
	var setVisibility = function () {
		scroll = window.scrollY || document.documentElement.scrollTop;
		if (scroll > viewportHeight + 100) {
			button.style.transform = 'translateY(0px)';
			button.style.opacity = '1';
		} else {
			button.style.transform = 'translateY(100px)';
			button.style.opacity = '0';
		}
	};
	var scrollTimer = false;
	window.addEventListener(
		'scroll',
		function () {
			clearTimeout(scrollTimer);
			scrollTimer = setTimeout(function () {
				setVisibility();
			}, 300);
		},
		false
	);
	button.addEventListener('click', function (e) {
		e.preventDefault();
		if (scroll > viewportHeight * 5) {
			window.scrollTo({ top: 0 });
		} else {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
	});
}

document.addEventListener('lichen:loaded', goToTop);

export default goToTop;
